import React from 'react';
import { toast } from 'react-toastify';

import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import { isArray } from 'lodash';

import { t, number } from '~/helpers';
import api from '~/services/api';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export default function TableCompartments({
  isFinalizado,
  listaDeCompartimentos,
  calculodensidadeproduto,
  onAtualizaCompartimentos,
  densidadecalculadaamostra20,
  constrolsAt20,
}) {
  const classes = useStyles();

  // Calcula a volume 20 compartimento
  const handleGetVolumePara20Graus = React.useCallback(
    async (
      compartimentodescarganfcompartimento,
      iddescarganfcompartimento,
      densidadeamostra20,
      temperaturaamostra,
      volumeambiente,
      calculodensidadeproduto
    ) => {
      if (
        densidadeamostra20 > 0 &&
        temperaturaamostra > 0 &&
        volumeambiente > 0
      ) {
        try {
          const { data } = await api.get(
            `/calculodensidades/converteVolumePara20Graus/${densidadeamostra20}/${temperaturaamostra}/${volumeambiente}/${calculodensidadeproduto}`
          );

          const { msgErroDensidadeAmbiente, msgErroTemperaturaAmbiente } = data;

          if (
            String(msgErroDensidadeAmbiente).length > 0 &&
            String(msgErroTemperaturaAmbiente).length > 0
          ) {
            const err = [
              `Compartimento ${compartimentodescarganfcompartimento} densidade 20 - ${msgErroDensidadeAmbiente}`,
              `Compartimento ${compartimentodescarganfcompartimento} temperatura - ${msgErroTemperaturaAmbiente}`,
            ];
            if (isArray(err)) err.map((e) => toast.error(t(e)));
          } else {
            if (String(msgErroTemperaturaAmbiente).length > 0) {
              const err = [
                `Compartimento ${compartimentodescarganfcompartimento} temperatura - ${msgErroTemperaturaAmbiente}`,
              ];
              if (isArray(err)) err.map((e) => toast.error(t(e)));
            }
            if (String(msgErroDensidadeAmbiente).length > 0) {
              const err = [
                `Compartimento ${compartimentodescarganfcompartimento} densidade 20 - ${msgErroDensidadeAmbiente}`,
              ];
              if (isArray(err)) err.map((e) => toast.error(t(e)));
            }
          }

          return data.volume20;
        } catch (err) {
          if (isArray(err)) err.map((e) => toast.error(t(e)));
          else toast.error(t(err));
        } finally {
        }
      } else {
      }
    },
    []
  );

  const handleChangeVolumeDeclaradoCompartimentos = React.useCallback(
    async (
      event,
      compartimentodescarganfcompartimento,
      iddescarganfcompartimento,
      listaDeCompartimentosAux
    ) => {
      const valorDigitado = Number(event.target.value);
      for (let idx = 0; idx < listaDeCompartimentosAux.length; idx++) {
        if (
          listaDeCompartimentosAux[idx].iddescarganfcompartimento ===
          iddescarganfcompartimento
        ) {
          listaDeCompartimentosAux[
            idx
          ].volumedeclaradodescarganfcompartimento = valorDigitado;
          listaDeCompartimentosAux[
            idx
          ].densidade20descarganfcompartimento = densidadecalculadaamostra20;
          if (
            listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento >
              0 &&
            listaDeCompartimentosAux[idx]
              .volumedeclaradodescarganfcompartimento > 0
          ) {
            const valor20 = await handleGetVolumePara20Graus(
              compartimentodescarganfcompartimento,
              iddescarganfcompartimento,
              densidadecalculadaamostra20,
              listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento,
              listaDeCompartimentosAux[idx]
                .volumedeclaradodescarganfcompartimento,
              calculodensidadeproduto
            );
            listaDeCompartimentosAux[
              idx
            ].volume20descarganfcompartimento = valor20;
          } else {
            listaDeCompartimentosAux[idx].volume20descarganfcompartimento = 0;
          }
          onAtualizaCompartimentos(listaDeCompartimentosAux);
        }
      }
    },
    [listaDeCompartimentos, densidadecalculadaamostra20]
  );

  const handleChangeTemperaturaCompartimentos = React.useCallback(
    async (
      event,
      compartimentodescarganfcompartimento,
      iddescarganfcompartimento,
      listaDeCompartimentosAux
    ) => {
      const valorDigitado = Number(event.target.value);
      for (let idx = 0; idx < listaDeCompartimentosAux.length; idx++) {
        if (
          listaDeCompartimentosAux[idx].iddescarganfcompartimento ===
          iddescarganfcompartimento
        ) {
          listaDeCompartimentosAux[
            idx
          ].temperaturadescarganfcompartimento = valorDigitado;
          listaDeCompartimentosAux[
            idx
          ].densidade20descarganfcompartimento = densidadecalculadaamostra20;
          if (
            listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento >
              0 &&
            listaDeCompartimentosAux[idx]
              .volumedeclaradodescarganfcompartimento > 0
          ) {
            const valor20 = await handleGetVolumePara20Graus(
              compartimentodescarganfcompartimento,
              iddescarganfcompartimento,
              densidadecalculadaamostra20,
              listaDeCompartimentosAux[idx].temperaturadescarganfcompartimento,
              listaDeCompartimentosAux[idx]
                .volumedeclaradodescarganfcompartimento,
              calculodensidadeproduto
            );
            listaDeCompartimentosAux[
              idx
            ].volume20descarganfcompartimento = valor20;
          } else {
            listaDeCompartimentosAux[idx].volume20descarganfcompartimento = 0;
          }
          onAtualizaCompartimentos(listaDeCompartimentosAux);
        }
      }
    },
    [listaDeCompartimentos, densidadecalculadaamostra20]
  );

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell>
              {t('s.operacao.recebimento.compartimentos.compartimento')}
            </TableCell>
            {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
              <TableCell align="right">
                {t('s.operacao.recebimento.densidade20amostratbdescarganf')}
              </TableCell>
            )}
            {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
              <TableCell align="right">
                {t('s.operacao.recebimento.compartimentos.temperatura')}
              </TableCell>
            )}
            <TableCell align="right">
              {t('s.operacao.recebimento.compartimentos.volumedeclarado')}
            </TableCell>
            {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
              <TableCell align="right">
                {t('s.operacao.recebimento.compartimentos.volume20')}
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {listaDeCompartimentos.map((compartimento) => (
            <TableRow key={compartimento.iddescarganfcompartimento}>
              <TableCell component="th" scope="row">
                {compartimento.compartimentodescarganfcompartimento}
              </TableCell>
              {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
                <TableCell align="right">
                  {densidadecalculadaamostra20}
                </TableCell>
              )}
              {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
                <TableCell align="right">
                  <TextField
                    disabled={isFinalizado}
                    InputProps={{
                      inputProps: {
                        max: 100,
                        min: 0,
                        pattern: '[0-9]*',
                        style: { textAlign: 'right', color: 'black' },
                      },
                    }}
                    type="number"
                    id={`compartimento_${compartimento.temperaturadescarganfcompartimento}`}
                    error={
                      compartimento.temperaturadescarganfcompartimento === 0
                    }
                    defaultValue={
                      compartimento.temperaturadescarganfcompartimento
                    }
                    onChange={(event) => {
                      handleChangeTemperaturaCompartimentos(
                        event,
                        compartimento.compartimentodescarganfcompartimento,
                        compartimento.iddescarganfcompartimento,
                        listaDeCompartimentos
                      );
                    }}
                    onKeyDown={(event) => {
                      const charCode = event.which
                        ? event.which
                        : event.keyCode;
                      if (
                        charCode === 8 ||
                        (charCode >= 46 && charCode <= 57)
                      ) {
                        // console.log(event.target.value);
                        // return true;
                      } else {
                        if (
                          charCode === 109 ||
                          charCode === 107 ||
                          charCode === 189 ||
                          charCode === 16
                        ) {
                          event.preventDefault();
                          event.target.value = '0';
                          return false;
                        }
                        // if (Number(event.target.value) > 99) {
                        //   event.preventDefault();
                        //   event.target.value = '0';
                        //   return false;
                        // }
                      }
                    }}
                    onKeyUp={(event) => {
                      const charCode = event.which
                        ? event.which
                        : event.keyCode;
                      if (
                        charCode === 8 ||
                        (charCode >= 46 && charCode <= 57)
                      ) {
                        // console.log(event.target.value);
                        // return true;
                      } else {
                        // if (Number(event.target.value) > 99) {
                        //   event.preventDefault();
                        //   event.target.value = '0';
                        //   return false;
                        // }
                      }

                      if (event.key === 'Enter') {
                        // console.log(event.target.value);
                        // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                      }
                    }}
                    onBlur={(event) => {
                      // handleAtualizaTemperaturaCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                    }}
                  />
                </TableCell>
              )}

              <TableCell align="right">
                <TextField
                  disabled={isFinalizado}
                  InputProps={{
                    inputProps: {
                      style: { textAlign: 'right', color: 'black' },
                    },
                  }}
                  type="number"
                  id={`compartimento_${compartimento.volumedeclaradodescarganfcompartimento}`}
                  error={
                    compartimento.volumedeclaradodescarganfcompartimento === 0
                  }
                  defaultValue={
                    compartimento.volumedeclaradodescarganfcompartimento
                  }
                  onChange={(event) => {
                    handleChangeVolumeDeclaradoCompartimentos(
                      event,
                      compartimento.compartimentodescarganfcompartimento,
                      compartimento.iddescarganfcompartimento,
                      listaDeCompartimentos
                    );
                  }}
                  onKeyUp={(event) => {
                    if (event.key === 'Enter') {
                      // handleAtualizaVolumeDeclaradoCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                    }
                  }}
                  onBlur={(event) => {
                    // handleAtualizaVolumeDeclaradoCompartimentos(event, compartimento.iddescarganfcompartimento, listaDeCompartimentos);
                  }}
                />
              </TableCell>

              {constrolsAt20 && Number(calculodensidadeproduto) >= 1 && (
                <TableCell align="right">
                  {number(compartimento.volume20descarganfcompartimento, 1)}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
